/**
 * Created by daniel on 17/04/17.
 *
 * Acts as a host for user-defined content. Manages editor lifecycle.
 *
 * Can only be placed in RowItem components.
 *
 */

import React, {Component} from 'react';
import StyleItem from "./StyleItem";
import DropZone from "../ui/DropZone";
import * as _ from "lodash/object";

class CellItem extends Component {
  render() {
    return (
      <td
        id={this.props.contentId}
        className={[this.props.contentId, this.props.viewClass,].join(" ").trim()}
        ref={(node) => {
          _.toPairs(this.props.viewAttributes).map((item) => {
            return node && node.setAttribute(item[0], item[1]);
          });
        }}
        {...this.props.eventHandlers}
        style={{
          width: this.props.styleWidth,
          height: this.props.styleHeight,
          padding: this.props.stylePadding,
          backgroundColor: this.props.styleBackgroundColour,
          color: this.props.styleTextColour,
          textAlign: this.props.styleTextAlignment,
        }}
      >
        <StyleItem selectorPrefix={this.props.contentId + " "} styleObject={this.props.viewCss}/>
        {
          this.props.children.length > 0 ? this.props.children : <DropZone text={this.props.configName}/>
        }
      </td>
    );
  }
}

export default CellItem;


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/CellItem.js